// extracted by mini-css-extract-plugin
export default {"footerPosition":"Thumbnail_footerPosition__HwWUM","pageThumbnail":"Thumbnail_pageThumbnail__IcDGF"};